<template>
  <div class="g-page">
    <div class="content-container">
      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">Brendlar</h2>
        <div class="header-actions">
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input v-model="filter" type="search" :placeholder="$t('Qidiruv...')" class="modern-search">
          </div>

          <button class="refresh-btn" @click="Refresh()" title="Yangilash">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>

          <button class="add-btn" @click="OpenModal()">
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}
          </button>

          <top></top>
        </div>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 80px">ID</th>
                <th style="width: 100px">{{ $t("Rasm") }}</th>
                <th>{{ $t("Nomi") }}</th>
                <th style="width: 120px; text-align: center;">{{ $t("Amallar") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in paginatedItems" :key="item.id" @dblclick="OpenModal(item)">
                <td><span class="id-badge">#{{ item.id }}</span></td>
                <td>
                  <div class="brand-img-wrapper">
                    <img v-if="item.image" :src="getImagePath(item.image)" class="brand-img">
                    <div v-else class="no-img-placeholder">{{ $t("Rasm yo'q") }}</div>
                  </div>
                </td>
                <td class="font-bold">{{ item.name }}</td>
                <td>
                  <div class="actions">
                    <button class="icon-btn edit" @click="OpenModal(item)">
                      <b-icon icon="pencil"></b-icon>
                    </button>
                    <button class="icon-btn del" @click="ConfirmTrash(item.id)">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="filteredItems.length === 0">
                <td colspan="4" class="empty-row text-center">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-footer">
          <div class="info">
            {{ totalRows }} {{ $t('ta listdan') }}
            {{ Math.min(currentPage * $store.state.countindex, totalRows) }} {{ $t('tasi') }}
          </div>
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="$store.state.countindex" align="right"
            size="sm" class="my-0 custom-pagination"></b-pagination>
        </div>
      </div>
    </div>

    <!-- FORM COMPONENT (MODAL SHU YERDA CHAQIRILADI) -->
    <FormModal v-model="showForm" :item-data="selectedItem" @saved="Refresh" />

    <!-- O'CHIRISHNI TASDIQLASH MODALI -->
    <b-modal id="modal-delete" hide-footer centered no-stacking no-close-on-backdrop>
      <div class="text-center p-3">
        <div class="warning-icon mb-3">!</div>
        <h3 class="fw-bold mb-2">{{ $t("O'chirishni tasdiqlaysizmi?") }}</h3>
        <p class="text-muted mb-4">{{ $t("Ushbu amalni ortga qaytarib bo'lmaydi.") }}</p>
        <div class="modal-custom-footer">
          <button class="m-btn cancel-btn" @click="$bvModal.hide('modal-delete')">{{ $t("YO'Q") }}</button>
          <button class="m-btn save-btn bg-danger" @click="DeleteData">{{ $t("HA, O'CHIRILSIN") }}</button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import Top from "../../Layout/Top.vue";
import FormModal from "./Form.vue"; // Form fayl manzilini to'g'rilang

export default {
  components: { Top, FormModal },
  data() {
    return {
      items: [],
      filter: "",
      currentPage: 1,

      // Form Modal uchun
      showForm: false,
      selectedItem: {},

      // O'chirish uchun
      itemToDeleteId: null
    };
  },
  computed: {
    filteredItems() {
      if (!this.filter) return this.items;
      const s = this.filter.toLowerCase();
      return this.items.filter(item =>
        item.name.toLowerCase().includes(s) ||
        item.id.toString().includes(s)
      );
    },
    totalRows() {
      return this.filteredItems.length;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.$store.state.countindex;
      return this.filteredItems.slice(start, start + this.$store.state.countindex);
    }
  },
  watch: {
    filter() {
      this.currentPage = 1;
    }
  },
  created() {
    this.Refresh();
  },
  methods: {
    getImagePath(imgName) {
      if (!imgName) return '';
      let baseUrl = (axios.defaults.baseURL || 'http://192.168.88.135:3000').replace(/\/$/, "");
      if (baseUrl.includes('/api/v1')) return `${baseUrl}/uploads/${imgName}`;
      return `${baseUrl}/api/v1/uploads/${imgName}`;
    },
    Refresh() {
      axios.get("api/v1/brand/").then(res => {
        this.items = res.data;
      });
    },
    OpenModal(item = null) {
      this.selectedItem = item ? { ...item } : { id: null };
      this.showForm = true;
    },
    ConfirmTrash(id) {
      this.itemToDeleteId = id;
      this.$bvModal.show('modal-delete');
    },
    DeleteData() {
      if (!this.itemToDeleteId) return;
      axios.delete("api/v1/brand/id/" + this.itemToDeleteId)
        .then(() => {
          this.$bvModal.hide('modal-delete');
          this.Refresh();
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>

<style scoped>
/* Page Layout */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Header */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
  font-size: 14px;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 38px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
  transition: 0.2s;
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Table Card */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 15px;
}

.id-badge {
  background: #f1f5f9;
  padding: 4px 10px;
  border-radius: 8px;
  font-family: monospace;
  font-weight: 700;
  color: #64748b;
}

.brand-img-wrapper {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  overflow: hidden;
  background: #f8fafc;
}

.brand-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
}

.empty-row {
  text-align: center;
  padding: 50px;
  color: #cbd5e1;
}

/* Delete Modal Specifics */
.warning-icon {
  width: 60px;
  height: 60px;
  background: #fee2e2;
  color: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: bold;
  margin: 0 auto;
}

.modal-custom-footer {
  display: flex;
  gap: 10px;
}

.m-btn {
  flex: 1;
  padding: 12px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.cancel-btn {
  background: #f1f5f9;
  color: #64748b;
}

.save-btn {
  background: #a142f4;
  color: white;
}
</style>